import {useState} from "react";
import type {Door} from "@/dungeons/model/DungeonGeometry.ts";
import {Button} from "@/components/ui/button.tsx";
import {Checkbox} from "@/components/ui/checkbox.tsx";
import {Input} from "@/components/ui/input.tsx";
import {Textarea} from "@/components/ui/textarea.tsx";
import {Trash2} from "lucide-react";

export default function DoorInspector({door, onChange, onDelete}: {
    door: Door;
    onChange: (changes: Partial<Pick<Door, "initialState" | "secret" | "label" | "notes">>) => void;
    onDelete: () => void;
}) {
    const [draft, setDraft] = useState<{label: string; notes: string}>();
    const label = draft?.label ?? door.label ?? "";
    const notes = draft?.notes ?? door.notes ?? "";

    const commitDetails = () => {
        const normalizedLabel = label.trim() || null;
        const normalizedNotes = notes.trim() || null;
        if (normalizedLabel !== (door.label ?? null) || normalizedNotes !== (door.notes ?? null)) {
            onChange({label: normalizedLabel, notes: normalizedNotes});
        }
        setDraft(undefined);
    };

    return <div className="space-y-3 text-sm">
        <p className="font-medium">Tür</p>
        <label className="block space-y-1">
            <span>Name</span>
            <Input value={label} maxLength={160} placeholder="Optional"
                   onChange={event => setDraft({label: event.target.value, notes})}
                   onBlur={commitDetails} onKeyDown={event => {
                       if (event.key === "Enter") event.currentTarget.blur();
                   }}/>
        </label>
        <label className="block space-y-1">
            <span>Notizen</span>
            <Textarea value={notes} maxLength={20_000} placeholder="Optional" className="min-h-24"
                      onChange={event => setDraft({label, notes: event.target.value})} onBlur={commitDetails}/>
        </label>
        <label className="flex cursor-pointer items-center gap-2">
            <Checkbox checked={door.initialState === "OPEN"}
                      onCheckedChange={checked => onChange({initialState: checked === true ? "OPEN" : "CLOSED"})}/>
            Initial geöffnet
        </label>
        <label className="flex cursor-pointer items-center gap-2">
            <Checkbox checked={door.secret}
                      onCheckedChange={checked => onChange({secret: checked === true})}/>
            Geheimtür
        </label>
        <Button type="button" size="sm" variant="destructive" onClick={onDelete}>
            <Trash2/> Tür löschen
        </Button>
    </div>;
}
